import { BMDivider } from "@traveloka/district-bloom";
import BMView from "../../../../../components/View/BMView";
import SelectNonEmployeeStepper from "./SelectNonEmployeeStepper";

export default function SelectNonEmployeeFlightContent() {
  return (
    <BMView spacing="lg">
      <SelectNonEmployeeStepper name="adults" type="adult" />
      <BMDivider type="SUBTLE" />
      <SelectNonEmployeeStepper name="children" type="child" />
      <BMDivider type="SUBTLE" />
      <SelectNonEmployeeStepper name="infants" type="infant" />
    </BMView>
  );
}
